import {ObjectLogType} from 'screens/ObjectsScreen/types';
import {AppState} from '../index';

interface State {
  [ObjectLogType.ObjectClick]: boolean;
  [ObjectLogType.PhoneClick]: boolean;
}

const initialState: State = {
  [ObjectLogType.ObjectClick]: false,
  [ObjectLogType.PhoneClick]: false,
};

const SET_CLICK_DATA = '@objects/set-click-data';

interface SetClickData {
  type: typeof SET_CLICK_DATA;
  data: {
    key: ObjectLogType,
    enabled: boolean
  };
}

export type ObjectClickAction =
  SetClickData;

export const objectsReducer = (
  state: State = initialState,
  action: ObjectClickAction,
) => {
  switch (action.type) {
    case SET_CLICK_DATA:
      return {
        ...state,
        [action.data.key]: action.data.enabled
      };

    default:
      return state;
  }
};

export const getObjectsState = (key: ObjectLogType) =>
  (state: AppState) => state.objects[key];

export const setObjectsState = (key: ObjectLogType, enabled: boolean) => {
  return {
    type: SET_CLICK_DATA,
    data: {
      key,
      enabled,
    },
  };
};
